const green100Color = '#C6ECCF';

export default green100Color;
